import { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Avatar } from '@mui/material';
import { text } from '../text';
import { hooks } from '../hooks';
import { svg } from '../assets/svg';
import { formatMoney, theme } from '../constants';
import { RootState } from '../store';
import { actions } from '../store/actions';
import FavoriteIcon from '@mui/icons-material/Favorite';
// import { TextField, InputAdornment } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { fetchCategories } from '../services/categoryService';
import SearchIcon from '@mui/icons-material/Search';
import { searchProducts } from '../services/searchService';
import { fetchNotifications } from '../services/notificationService';
import { fetchProfile } from '../services/authService';
import Main_Logo_green from '../assets/images/Main_Logo_green.png';
// import Smaller_Main_logo_green from '../assets/images/Icon_Green.png';
import useMediaQuery from '../hooks/useMediaQuery';
import useEmblaCarousel from 'embla-carousel-react';
// import { relative } from 'path';

type Props = {
  title?: string;
  line?: boolean;
  burger?: boolean;
  goBack?: boolean;
  basket?: boolean;
  navlink?: boolean;
  logo?: boolean;
};

export const Header: React.FC<Props> = ({
  line,
  title,
  burger,
  goBack,
  basket,
  navlink,
  logo,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [categories, setCategories] = useState<any[]>([]);
  const [hoveredTab, setHoveredTab] = useState<string | null>(null);
  const [activeTab, setActiveTab] = useState<string>('');
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState<any[]>([]);
  const [showResults, setShowResults] = useState(false);
  const [notifications, setNotifications] = useState<any[]>([]);
  const [profile, setProfile] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [hoveredCategory, setHoveredCategory] = useState<string | null>(null);
  const isSmallScreen = useMediaQuery('(max-width: 800px)');
  const isMediumScreen = useMediaQuery(
    '(min-width: 801px) and (max-width:1000px)'
  );
  // const isLargeScreen = useMediaQuery(
  //   '(min-width: 1001px) and (max-width: 1800px)'
  // );

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  const { list } = hooks.useAppSelector((state: RootState) => state.cartSlice);

  const [emblaRef] = useEmblaCarousel({
    align: 'start',
    containScroll: 'trimSnaps',
    dragFree: true,
  });

  const logoSrc = isSmallScreen ? Main_Logo_green : Main_Logo_green;
  // console.log('isSmallScreen', isSmallScreen);
  // console.log('isMediumScreen', isMediumScreen);
  useEffect(() => {
    const storedProfile = localStorage.getItem('profile');
    if (storedProfile) {
      setProfile(JSON.parse(storedProfile));
    } else {
      fetchProfile()
        .then((data) => {
          setProfile(data);
        })
        .catch((error) => {
          console.error('Error loading profile:', error);
        });
    }
  }, []);
  useEffect(() => {
    const loadCategories = async () => {
      try {
        setLoading(true);
        const categoriesData = await fetchCategories();
        setCategories(categoriesData);
      } catch (error) {
        console.error('Failed to load categories:', error);
      } finally {
        setLoading(false);
      }
    };

    loadCategories();
  }, []);

  useEffect(() => {
    fetchNotifications()
      .then((data) => {
        setNotifications(data.data);
      })
      .catch((error) => {
  //      console.error(error);
      });
  }, []);

  useEffect(() => {
    if (searchTerm.length >= 2) {
      searchProducts(searchTerm)
        .then((data) => {
          setSearchResults(data.data.data); // assuming your data is in the "data" field
          setShowResults(true);
        })
        .catch((error) => {
    //      console.error(error);
        });
    } else {
      setShowResults(false);
    }
  }, [searchTerm]);
  const handleNavigation = (path: string) => {
    setActiveTab(path);
    navigate(path);
  };
  const dispatch = hooks.useAppDispatch();
  // console.log(notifications);
  useEffect(() => {
    if (modal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [modal]);

  const cart = hooks.useAppSelector((state: RootState) => state.cartSlice.list);
  const total = hooks.useAppSelector(
    (state: RootState) => state.cartSlice.total
  );

  const handleOnClick = () => {
    console.log('object');
    dispatch(actions.setScreen('Order'));
    navigate('/Order');
  };
  const renderLogo = (): JSX.Element | null => {
    if (logo) {
      return (
        <img
          src={logoSrc} // Use the determined logo source
          alt='Logo'
          width={isSmallScreen ? 10 : 20}
          height={isSmallScreen ? 10 : 20}
          style={{
            position: 'absolute',
            left: 0,
            padding: 20,
            cursor: 'pointer',
          }}
          onClick={() => navigate('/Home')}
        />
      );
    }

    return null;
  };

  const renderGoBack = (): JSX.Element | null => {
    if (goBack) {
      return (
        <button
          style={{ position: 'absolute', left: 0, padding: 20 }}
          onClick={() => navigate(-1)}
        >
          <svg.GoBackSvg />
        </button>
      );
    }

    return null;
  };
  const SearchBar = () => {
    return (
      <div style={{ position: 'relative', width: '100%', maxWidth: '600px' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            border: '1px solid #e0e0e0',
            borderRadius: '8px',
            padding: '8px 16px',
            backgroundColor: 'white',
            width: isSmallScreen ? '100%' : isMediumScreen ? '90%' : '100%',
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
            transition: 'all 0.3s ease',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.boxShadow = '0px 4px 8px rgba(0, 0, 0, 0.1)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.boxShadow = '0px 2px 4px rgba(0, 0, 0, 0.05)';
          }}
        >
          <SearchIcon
            style={{ color: theme.colors.mainColor, marginRight: '12px' }}
          />
          <input
            type='text'
            placeholder='What are you looking for?'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              border: 'none',
              outline: 'none',
              width: '100%',
              fontSize: '14px',
              backgroundColor: 'transparent',
            }}
            onFocus={(e) => {
              e.target.style.outline = 'none';
            }}
          />
        </div>

        {showResults && (
          <div
            style={{
              position: 'absolute',
              top: '100%',
              left: 0,
              backgroundColor: 'white',
              border: '1px solid #ccc',
              boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
              zIndex: 1000,
              width: isSmallScreen
                ? '200px'
                : isMediumScreen
                ? '300px'
                : '400px',
              maxHeight: '300px',
              overflowY: 'auto',
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
              gap: '10px',
              padding: '10px',
            }}
          >
            {searchResults.length > 0 ? (
              searchResults.map((item) => (
                <div
                  key={item.id}
                  style={{
                    padding: '10px',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s ease',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                  onClick={() => {
                    navigate('/product', { state: { item } });
                    setSearchTerm('');
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = '#FFD6D7')
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = 'white')
                  }
                >
                  <img
                    src={item.attachments.product_main}
                    alt={item.name}
                    style={{ width: '50px', marginRight: '10px' }}
                  />
                  {item.name}
                </div>
              ))
            ) : (
              <div
                style={{ padding: '10px', textAlign: 'center', color: 'gray' }}
              >
                No items available
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  // const renderBurger = (): JSX.Element | null => {
  //   if (burger) {
  //     return (
  //       <button
  //         style={{
  //           position: 'absolute',
  //           left: 0,
  //           padding: 20,
  //           cursor: 'pointer',
  //           backgroundColor: 'transparent',
  //           border: 'none',
  //         }}
  //         onClick={() => setModal(true)}
  //       >
  //         <svg.BurgerSvg />
  //       </button>
  //     );
  //   }

  //   return null;
  // };

  const renderTitle = (): JSX.Element => {
    return (
      <text.T16
        style={{
          marginTop: 80,
          left: '50%',
          textAlign: 'center',
          position: 'absolute',
          width: 'calc(100% - 100px)',
          transform: 'translateX(-50%)',
          color: theme.colors.mainColor,
        }}
      >
        {title}
      </text.T16>
    );
  };

  const renderPromotion = () => {
    return (
      <div
        style={{
          width: '100vw',
          marginLeft: 'calc(-50vw + 50%)',
          padding: '8px 0',
          fontSize: 12,
          color: theme.colors.black,
          ...theme.fonts.DM_Sans_700Bold,
          backgroundColor: theme.colors.mainYellow,
          textAlign: 'center',
          boxSizing: 'border-box',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        📍 Pickup Location: United Nations ECA Compound Only
      </div>
    );
  };

  // Then in your header component, use it like this:
  <div style={{ width: '100%', overflow: 'hidden' }}>{renderPromotion()}</div>;
  const avatarDropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isDropdownOpen) return;
    function handleClickOutside(event: MouseEvent) {
      if (
        avatarDropdownRef.current &&
        !avatarDropdownRef.current.contains(event.target as Node)
      ) {
        closeDropdown();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen]);

  const renderAvatar = () => {
    if (profile) {
      const initials = profile.first_name[0] + profile.last_name[0];
      return (
        <div style={{ position: 'relative' }} ref={avatarDropdownRef}>
          <Avatar
            alt='Profile'
            style={{
              fontSize: '14px',
              fontWeight: 'bold',
              marginTop: 5,
              position: 'absolute',
              right: 10,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: theme.colors.mainColor,
              width: 40,
              height: 40,
              borderRadius: '50%',
              cursor: 'pointer',
            }}
            onClick={toggleDropdown}
          >
            {initials}
          </Avatar>

          {isDropdownOpen && (
            <div style={{
                position: 'absolute',
                right: 10,
                top: 50,
                backgroundColor: 'white',
                borderRadius: 8,
                boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                zIndex: 1000,
                minWidth: 200,
            }}>
              <div
                style={{
                  padding: '12px 16px',
                  cursor: 'pointer',

                }}
                onClick={() => {
                  handleNavigation('/OrderHistory');
                  closeDropdown();
                }}
              >
                My Orders
              </div>
              <div
                style={{
                  padding: '12px 16px',
                  cursor: 'pointer',

                }}
                onClick={() => {
                  handleNavigation('/change-password');
                  closeDropdown();
                }}
              >
                Change password
              </div>

              <div
                style={{
                  padding: '12px 16px',
                  cursor: 'pointer',

                }}
                onClick={() => {
                  navigate('/SignOut');
                }}
              >
                Sign Out
              </div>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <Avatar
          alt='Default Profile'
          src='data:image/png;base64,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' // Replace with your default avatar image path
          style={{
            marginTop: 2,
            position: 'absolute',
            right: 10,
            cursor: 'pointer',
          }}
          onClick={() => handleNavigation('/SignIn')}
        />
      );
    }
  };
  const renderBasket = (): JSX.Element | null => {
    const unreadCount = notifications.filter((n) => !n.read_at).length;

    if (basket) {
      if (isSmallScreen) {
        return (
          <>
            <button
              style={{
                position: 'absolute',
                right: 10,
                padding: 10,
                cursor: 'pointer',
                backgroundColor: 'transparent',
                border: 'none',
              }}
              onClick={() => setModal(!modal)}
            >
              <svg.BurgerSvg />
            </button>{' '}
            {modal && (
              <div
                style={{
                  position: 'fixed',
                  top: 0,
                  right: 0,
                  width: '280px',
                  height: '100vh',
                  backgroundColor: 'white',
                  boxShadow: '-2px 0 10px rgba(0,0,0,0.1)',
                  zIndex: 1000,
                  padding: '20px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '20px',
                  overflowY: 'auto',
                }}
              >
                <button
                  style={{
                    position: 'absolute',
                    top: '20px',
                    right: '20px',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: '5px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: theme.colors.mainColor,
                    fontSize: '24px',
                    fontWeight: 'bold',
                  }}
                  onClick={() => setModal(false)}
                >
                  ×
                </button>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '15px',
                    padding: '15px',
                    borderRadius: '8px',
                    marginBottom: '20px',
                    borderBottom: `1px solid ${theme.colors.aliceBlue2}`,
                    backgroundColor: theme.colors.aliceBlue2,
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '15px',
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      navigate('/Profile');
                      setModal(false);
                    }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <span
                        style={{
                          fontSize: '16px',
                          fontWeight: '600',
                          color: theme.colors.mainColor,
                        }}
                      >
                        {profile
                          ? `${profile.first_name} ${profile.last_name}`
                          : 'User'}
                      </span>
                      <span
                        style={{
                          fontSize: '14px',
                          color: '#666',
                          marginTop: '2px',
                        }}
                      >
                        {profile?.email || 'Sign in to your account'}
                      </span>
                    </div>
                  </div>
                  {profile ? (
                    <div
                      style={{
                        display: 'flex',
                        gap: '10px',
                        marginTop: '10px',
                      }}
                    >
                      {/* <button
                        style={{
                          flex: 1,
                          padding: '8px 12px',
                          borderRadius: '6px',
                          border: 'none',
                          backgroundColor: theme.colors.mainColor,
                          color: 'white',
                          fontSize: '14px',
                          fontWeight: '500',
                          cursor: 'pointer',
                          transition: 'background-color 0.3s ease',
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#005800';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor =
                            theme.colors.mainColor;
                        }}
                        onClick={() => {
                          navigate('/Profile');
                          setModal(false);
                        }}
                      >
                        View Profile
                      </button> */}
                      <button
                        style={{
                          flex: 1,
                          padding: '8px 12px',
                          borderRadius: '6px',
                          border: `1px solid ${theme.colors.mainColor}`,
                          backgroundColor: 'transparent',
                          color: theme.colors.mainColor,
                          fontSize: '14px',
                          fontWeight: '500',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease',
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor =
                            theme.colors.aliceBlue2;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = 'transparent';
                        }}
                        onClick={() => {
                          localStorage.removeItem('profile');
                          navigate('/SignOut');
                          setModal(false);
                        }}
                      >
                        Sign Out
                      </button>
                    </div>
                  ) : (
                    <button
                      style={{
                        width: '100%',
                        padding: '8px 12px',
                        borderRadius: '6px',
                        border: 'none',
                        backgroundColor: theme.colors.mainColor,
                        color: 'white',
                        fontSize: '14px',
                        fontWeight: '500',
                        cursor: 'pointer',
                        transition: 'background-color 0.3s ease',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#005840';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor =
                          theme.colors.mainColor;
                      }}
                      onClick={() => {
                        navigate('/SignIn');
                        setModal(false);
                      }}
                    >
                      Sign In
                    </button>
                  )}
                </div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '15px',
                    padding: '12px 15px',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s ease',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor =
                      theme.colors.aliceBlue2;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }}
                  onClick={handleOnClick}
                >
                  <svg.BasketSvg />
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span
                      style={{
                        fontSize: '16px',
                        fontWeight: '500',
                        color: theme.colors.mainColor,
                      }}
                    >
                      Cart
                    </span>
                    <span
                      style={{
                        fontSize: '14px',
                        color: '#666',
                        marginTop: '2px',
                      }}
                    >
                      {cart.length > 0
                        ? ` ETB  ${formatMoney(total)}`
                        : ' ETB  0'}
                    </span>
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '15px',
                    padding: '12px 15px',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s ease',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor =
                      theme.colors.aliceBlue2;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }}
                  onClick={() => navigate('/change-password')}
                >
                  <svg.ChangePasswordSvg />

                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span
                      style={{
                        fontSize: '16px',
                        fontWeight: '500',
                        color: theme.colors.mainColor,
                      }}
                    >
                      Change password
                    </span>

                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '15px',
                    padding: '12px 15px',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s ease',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor =
                      theme.colors.aliceBlue2;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }}
                  onClick={() => navigate('/OrderHistory')}
                >
                  <svg.ServerSvg />

                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span
                      style={{
                        fontSize: '16px',
                        fontWeight: '500',
                        color: theme.colors.mainColor,
                      }}
                    >
                      My Orders
                    </span>

                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '15px',
                    padding: '12px 15px',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s ease',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor =
                      theme.colors.aliceBlue2;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }}
                  // onClick={() => {
                  //   navigate('/notifications', { state: { notifications } });
                  //   setModal(false);
                  // }}
                  onClick={() =>
                    navigate('/notifications', { state: { notifications } })
                  }
                >
                  <div style={{ position: 'relative' }}>
                    <NotificationsIcon
                      style={{
                        color: theme.colors.mainColor,
                        fontSize: '24px',
                      }}
                    />
                    {unreadCount > 0 && (
                      <span
                        style={{
                          position: 'absolute',
                          top: '-5px',
                          right: '-5px',
                          backgroundColor: theme.colors.mainColor,
                          color: 'white',
                          borderRadius: '50%',
                          width: '18px',
                          height: '18px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '12px',
                          fontWeight: 'bold',
                        }}
                      >
                        {unreadCount}
                      </span>
                    )}
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span
                      style={{
                        fontSize: '16px',
                        fontWeight: '500',
                        color: theme.colors.mainColor,
                      }}
                    >
                      Notifications
                    </span>
                    <span
                      style={{
                        fontSize: '14px',
                        color: '#666',
                        marginTop: '2px',
                      }}
                    >
                      {unreadCount} unread
                    </span>
                  </div>
                </div>

                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '15px',
                    padding: '12px 15px',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s ease',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor =
                      theme.colors.aliceBlue2;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }}
                  onClick={() => navigate('/wishlist')}
                >
                  <FavoriteIcon
                    style={{
                      color: theme.colors.coralRed,
                      fontSize: '24px',
                    }}
                  />
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span
                      style={{
                        fontSize: '16px',
                        fontWeight: '500',
                        color: theme.colors.mainColor,
                      }}
                    >
                      Wishlist
                    </span>
                    <span
                      style={{
                        fontSize: '14px',
                        color: '#666',
                        marginTop: '2px',
                      }}
                    >
                      Your saved items
                    </span>
                  </div>
                </div>


                <div
                  style={{
                    marginTop: 'auto',
                    paddingTop: '20px',
                    borderTop: `1px solid ${theme.colors.aliceBlue2}`,
                  }}
                ></div>
              </div>
            )}
          </>
        );
      }

      return (
        <div style={{ position: 'relative', top: '-30px' }}>
          <button
            onClick={handleOnClick}
            style={{
              position: 'absolute',
              right: 130,
              paddingTop: 12,
              paddingBottom: 12,
              paddingLeft: 20,
              paddingRight: 20,
              borderRadius: 12,
              alignItems: 'center',
            }}
          >
            <svg.BasketSvg />
            {list.length > 0 && (
              <p
                className=''
                style={{
                  position: 'absolute',
                  right: 5,
                  top: 5,
                  backgroundColor: theme.colors.mainColor,
                  color: 'white',
                  borderRadius: '50%',
                  width: '18px',
                  height: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '12px',
                  fontWeight: 'bold',
                }}
              >
                {list.length}
              </p>
            )}
            <span
              style={{
                padding: '6px 12px',
                borderRadius: 6,
                right: 48,
                // bottom: 16,
                position: 'absolute',
                fontSize: 12,
                color: theme.colors.black,
                ...theme.fonts.DM_Sans_700Bold,
                backgroundColor: theme.colors.mainYellow,
                whiteSpace: 'nowrap',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '2px',
              }}
            >
              ETB {cart.length > 0 ? formatMoney(total) : '0'}
            </span>
          </button>
          <button
            onClick={() => navigate('/notifications', { state: { notifications } })}
            style={{
              position: 'absolute',
              right: 85,
              paddingTop: 12,
              paddingBottom: 12,
              paddingLeft: 20,
              paddingRight: 20,
              borderRadius: 12,
            }}
          >
            <NotificationsIcon
              style={{
                color: theme.colors.mainColor,
                fontSize: '26px',
              }}
            />
            {unreadCount > 0 && (
              <span
                style={{
                  position: 'absolute',
                  top: 8,
                  right: 8,
                  backgroundColor: theme.colors.mainColor,
                  color: 'white',
                  borderRadius: '50%',
                  width: '18px',
                  height: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '12px',
                  fontWeight: 'bold',
                }}
              >
                {unreadCount}
              </span>
            )}
          </button>
          <button
            onClick={() => navigate('/wishlist')}
            style={{
              position: 'absolute',
              right: 50,
              paddingTop: 12,
              paddingBottom: 12,
              paddingLeft: 20,
              paddingRight: 20,
              borderRadius: 12,
            }}
          >
            <FavoriteIcon
              style={{
                color: 'transparent',
                stroke: theme.colors.coralRed,
                strokeWidth: 2,
              }}
            />

          </button>

          {renderAvatar()}
        </div>
      );
    }

    return null;
  };
  const rendermainlogo = (): JSX.Element | null => {
    if (basket) {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <img
            src={logoSrc}
            alt='Logo'
            style={{
              width: isSmallScreen ? '100px' : '150px',
              height: isSmallScreen ? '60px' : '90px',
              marginRight: 'auto',
              left: 0,
              cursor: 'pointer',


            }}
            onClick={() => navigate('/Home')}
          />
          {/* <text.T14 style={{
            color: theme.colors.mainColor,
            fontWeight: 'bold',
            marginTop: isSmallScreen ? '-5px' : '-20px',
            marginLeft: isSmallScreen ? '5px' : '10px',
            fontSize: isSmallScreen ? "12px" : "14px",
            display: isSmallScreen ? "none" : "flex",
            textAlign: 'center'
          }}>
            By Rungo Diplomatic Trading Plc
          </text.T14> */}
        </div>
      );
    }
    return null;
  };

  const renderNavLinks = (): JSX.Element | null => {
    const currentProductId = location?.state?.products?.id;
    if (loading) return null;

    const navLinkStyle = {
      cursor: 'pointer',
      background: 'none',
      border: 'none',
      padding: '10px',
      fontSize: '13px',
      transition: 'color 0.3s',
      position: 'relative' as const,

    };
    
    // const activeStyle = {
    //   color: theme.colors.mainColor,
    // };

    const handleNavigation = (path: string) => {
      setActiveTab(path);
      navigate(path);
    };

    const renderDropdownMenu = (category: any) => (
      <div
        style={{
          // position: 'absolute',
          // top: '100%',
          // left: 0,
          marginTop: "-20px",
          backgroundColor: 'white',
          border: '1px solid #ccc',
          boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
          zIndex: 100,
          width: '200px',
          opacity: hoveredTab === category.name ? 1 : 0,
          visibility: hoveredTab === category.name ? 'visible' : 'hidden',
          transform:
            hoveredTab === category.name
              ? 'translateY(0)'
              : 'translateY(-10px)',
          transition:
            'opacity 0.3s ease, transform 0.3s ease, visibility 0.3s ease',
          pointerEvents: hoveredTab === category.name ? 'auto' : 'none',
        }}
        onMouseEnter={() => setHoveredTab(category.name)}
        onMouseLeave={() => setHoveredTab(null)}
      >
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {category.child.map((subCategory: any) => (
            <div
              key={subCategory.id}
              style={{ position: 'relative', width: '100%' }}
              onMouseEnter={() => setHoveredCategory(subCategory.name)}
              onMouseLeave={() => setHoveredCategory(null)}
            >
              <li
                style={{
                  padding: '1px 10px 0px 10px',
                  cursor: 'pointer',
                  color:
                    hoveredCategory === subCategory.name
                      ? theme.colors.black
                      : theme.colors.black,
                  position: 'relative',
                  transition: 'color 0.3s ease',
                }}
                onClick={() => {
                  setActiveTab(category.name);
                  localStorage.setItem('childId', subCategory.id);
                  navigate('/shop', {
                    state: {
                      products: category,
                      childId: subCategory.id,
                      title: 'Shop',
                    },
                  });
                }}
              >
                <text.T16>{subCategory.name}</text.T16>

                <span
                  style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    height: '2px',
                    backgroundColor: theme.colors.mainYellow,
                    width: hoveredCategory === subCategory.name ? '100%' : '0%',
                    transition: 'width 0.3s ease',
                  }}
                />
              </li>
            </div>
          ))}
        </ul>
      </div>
    );

    return (
      <div
        className='embla'
        ref={emblaRef}
        style={{ position: 'relative', zIndex: 1, marginTop: isSmallScreen ? '-8px' : '-20px' }}
      >
        <div className='embla__container' style={{ display: 'flex' }}>
          <div
            className='embla__slide'
            style={{
              position: 'relative',
              flex: '0 0 auto',
              minWidth: 0,
              marginRight: '50px',
            }}
            onMouseEnter={() => setHoveredTab('Home')}
            onMouseLeave={() => {
              if (hoveredTab === 'Home') setHoveredTab(null);
            }}
          >
            <button
              style={{
                ...navLinkStyle,
                fontWeight: activeTab === 'Home' ? 'bold' : 'normal',
                color: activeTab === 'Home' ? theme.colors.mainColor : 'black',
                position: 'relative',
              }}
              onClick={() => handleNavigation('/home')}
              onMouseEnter={() => setHoveredTab('Home')}
              onMouseLeave={() => {
                if (hoveredTab === 'Home' && !activeTab) setHoveredTab(null);
              }}
            >
              <text.H5>Home</text.H5>
              <span
                style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  height: '2px',
                  backgroundColor: theme.colors.mainColor,
                  // width: activeTab === 'Home' ? '100%' : '0%',
                  width:
                    hoveredTab === 'Home' || activeTab === 'Home'
                      ? '100%'
                      : '0%',
                  transition: 'width 0.3s ease',
                }}
              />
            </button>
          </div>

          {categories.map((category) => (
            <div
              key={category.id}
              className='embla__slide'
              style={{
                position: 'relative',
                flex: '0 0 auto',
                minWidth: 0,
                marginRight: '50px',
              }}
              onMouseEnter={() => setHoveredTab(category.name)}
              onMouseLeave={() => {
                if (hoveredTab === category.name) setHoveredTab(null);
              }}
            >
              <button
                style={{
                  ...navLinkStyle,
                  fontWeight: activeTab === category.name ? 'bold' : 'normal',
                  color:
                    activeTab === category.name
                      ? theme.colors.mainColor
                      : 'black',
                  position: 'relative',
                }}
                onMouseEnter={() => setHoveredTab(category.name)}
                onMouseLeave={() => {
                  if (hoveredTab === category.name && !activeTab)
                    setHoveredTab(null);
                }}
              >
                {currentProductId !== category?.id ? (
                  <text.H5>{category.name}</text.H5>
                ) : (
                  <text.H5 style={{ color: theme.colors.mainColor }}>{category.name}</text.H5>
                )}
                <span
                  style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    height: '2px',
                    backgroundColor: theme.colors.mainColor,
                    width:
                      hoveredTab === category.name ||
                      activeTab === category.name
                        ? '100%'
                        : '0%',
                    transition: 'width 0.3s ease',
                  }}
                />
              </button>

              {hoveredTab === category.name && renderDropdownMenu(category)}
            </div>
          ))}
        </div>
      </div>
    );
  };

  // const headerStyle: React.CSSProperties = {
  //   top: 0,
  //   height: 52,
  //   width: '100%',
  //   position: 'fixed',
  //   zIndex: 4,
  //   display: 'flex',
  //   alignItems: 'center',
  //   justifyContent: 'space-between',
  //   backgroundColor: theme.colors.white,
  //   borderBottom: line ? `1px solid ${theme.colors.aliceBlue2}` : 'none',
  //   padding: '0 20px',
  // };

  return (
    <>
      <header
        style={{
          top: 0,
          width: '100%',
          zIndex: 4,
          height: isSmallScreen ? '160px' : '200px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: isSmallScreen ? '10px 20px' : '10px 20px',
          backgroundColor: 'white',
          position: 'fixed',
          boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.08)',
        }}
      >
        <div style={{width: '100%'}}>{renderPromotion()}</div>

        <div
          style={{
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
            maxWidth: '1400px',
            margin: '0 auto',
          }}
        >
          <div style={{flex: 1}}>{rendermainlogo()}</div>

          <div
            style={{
              flex: 2,
              display: 'flex',
              justifyContent: 'center',
              margin: isSmallScreen ? '0 20px' : '0 40px',
            }}
          >
            {SearchBar()}
          </div>

          <div
            style={{
              flex: 1,
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              gap: '20px',
            }}
          >
            {renderBasket()}
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            width: '100%',
            maxWidth: '1400px',
            margin: '0 auto',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: isSmallScreen ? '10px' : '20px',
          }}
        >
          {renderGoBack()}
          {renderLogo()}
          {renderNavLinks()}
          {renderTitle()}
        </div>
      </header>
    </>
  );
};
